//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ALL_ELECTRONICS_PRODUCT_TYPES } from '@/scripts/constants/pdp'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-rox-panel-skeleton',
  props: {
    productType: {
      type: String,
      default: '',
    },
  },
  computed: {
    isProductMeta() {
      return ALL_ELECTRONICS_PRODUCT_TYPES.includes(this.productType)
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  methods: {
    hideOverlay() {
      this.$refs.overlay.style.zIndex = 0
    },
  },
}
